<svg [ngClass]="type" *ngIf="type === 'danger'" xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 12 12" height="12"
	width="12">
	<title>DANGER</title>
	<g transform="matrix(0.5,0,0,0.5,0,0)">
		<path
			d="M 12,18.75c-0.207,0-0.375,0.168-0.375,0.375S11.793,19.5,12,19.5s0.375-0.168,0.375-0.375 S12.207,18.75,12,18.75L12,18.75 "
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M 12,15.75v-7.5 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round"></path>
		<path
			d="M 13.621,1.76c-0.44-0.895-1.522-1.265-2.417-0.825 c-0.359,0.176-0.649,0.466-0.825,0.825L0.906,21.058c-0.371,0.754-0.06,1.665,0.694,2.036c0.209,0.103,0.439,0.156,0.672,0.156 h19.456c0.84,0.001,1.521-0.68,1.522-1.52c0-0.233-0.053-0.463-0.156-0.672L13.621,1.76z"
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
	</g>
</svg>
<svg [ngClass]="type" *ngIf="type === 'error' || type === 'warn'" xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 12 12" height="12"
	width="12">
	<title>ERROR</title>
	<g transform="matrix(0.5,0,0,0.5,0,0)">
		<path
			d="M 12,16.5c-0.207,0-0.375,0.168-0.375,0.375S11.793,17.25,12,17.25s0.375-0.168,0.375-0.375 S12.207,16.5,12,16.5L12,16.5 "
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
		<path d="M 12,13.5V5.25 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round"
			stroke-linejoin="round"></path>
		<path
			d="M 12,0.75c6.213,0,11.25,5.037,11.25,11.25S18.213,23.25,12,23.25S0.75,18.213,0.75,12 S5.787,0.75,12,0.75z"
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
	</g>
</svg>
<svg [ngClass]="type" *ngIf="type === 'info'" xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 12 12" height="12"
	width="12">
	<title>INFO</title>
	<g transform="matrix(0.5,0,0,0.5,0,0)">
		<path d="M 14.25,16.5H13.5c-0.828,0-1.5-0.672-1.5-1.5v-3.75c0-0.414-0.336-0.75-0.75-0.75H10.5 "
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
		<path
			d="M 11.625,6.75 c-0.207,0-0.375,0.168-0.375,0.375S11.418,7.5,11.625,7.5S12,7.332,12,7.125S11.832,6.75,11.625,6.75L11.625,6.75 "
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
		<path
			d="M 12,0.75 c6.213,0,11.25,5.037,11.25,11.25S18.213,23.25,12,23.25S0.75,18.213,0.75,12S5.787,0.75,12,0.75z"
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
	</g>
</svg>
<svg [ngClass]="type" *ngIf="type === 'success'" xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 12 12" height="12"
	width="12">
	<title>SUCCESS</title>
	<g transform="matrix(0.5,0,0,0.5,0,0)">
		<path d="M 6,13.223L8.45,16.7c0.322,0.481,0.974,0.61,1.455,0.288c0.096-0.065,0.182-0.145,0.252-0.237L18,6.828 "
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
		<path
			d="M 12,0.749c6.213,0,11.25,5.037,11.25,11.25S18.213,23.249,12,23.249S0.75,18.212,0.75,11.999S5.787,0.749,12,0.749z"
			stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
	</g>
</svg>
<span [ngClass]="type">
	<ng-content></ng-content>
</span>
